// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"4944eff4","165":"6b317fa6","372":"85661d67","429":"ac9be034","431":"b6737f83","435":"ed76f8c6","500":"ed6d4d53","551":"962ffc19","915":"28ef1040"}[chunkId] + ".chunk.js";
};